import qs from 'qs';
import { REQUESTOR } from 'src/utils/Constants';

const BASE_URL = 'https://siteflow.merch.vpsvc.com/v2';

export interface MultiNextStep {
  flows: Flow[];
}

export interface Flow {
  action: string;
  url: string;
  urls: string[];
  flowAction: string;
  type: string;
}

export async function getMultiNextStep(
  culture: string,
  productKey: string,
  productVersion: number,
  productOptions: { [name: string]: string },
  quantity?: number
): Promise<MultiNextStep> {
  const queryParams = {
    optionValues: productOptions,
    quantity,
    requestor: REQUESTOR,
  };

  const sfServiceUrl = `${BASE_URL}/multinextstep/vistaprint/${culture}/UploadAndPrint/${productKey}/${productVersion}?${qs.stringify(
    queryParams
  )}`;
  const response = await fetch(sfServiceUrl, {
    method: 'GET',
  });

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(`Error getting multi next step: ${response.status} ${response.statusText} ${JSON.stringify(response)}`);
  }
}
